import auth from '../../../config/app-specific-config/auth'
import * as types from './dsr-template-actions-types'

import { axiosInstance } from '../../../config/app-specific-config/axiosConfig'
import { displayModeCheck } from '../../global/helpers/global-helpers'
import { findPageIdByPageType } from '../helpers/dsr-helpers'
import { setIsLockedRoom, setIsMobileView, setLockedRoomLiveMetadata } from '../../global/actions/global-actions'
import { manageSharedDoc, setDsrDraftStatus, setDsrFaqContent, setDsrLastUpdated, setDsrLogos, setDsrPages, setDsrProperties, setDsrSharedDocsOverview, setDsrTitle, setFaqPageId, setInvalidRequest } from './dsr-actions'


// Set DSR Template ID
export const setDsrTemplateId = (p) => {
	return {
		type: types.SET_DSR_TEMPLATE_ID,
		payload: p
	};
}

export const setDsrTemplateMainContact = (p) => {
	return {
		type: types.SET_DSR_TEMPLATE_MAIN_CONTACT,
		payload: p
	};
}

export function fetchDsrTemplateData(dsrTemplateId, type) {
	return async (dispatch) => {
		dispatch(getTemplateConfig(dsrTemplateId, type))
		dispatch(manageSharedDoc({manageEvent:"get-dsr-shared-doc", dsrId: dsrTemplateId}))

		const isMobileView = displayModeCheck();
		dispatch(setIsMobileView(isMobileView))
	}
}


// Create DSR Template
export const createTemplateDsrSuccess = (response) => {
	return {
		type: types.CREATE_DSR_TEMPLATE_SUCCESS,
		payload: response.data
	};
};

export const createTemplateDsrFailure = (error) => {
	return {
		type: types.CREATE_DSR_TEMPLATE_FAILURE,
		error
	};
};

export const createTemplateDsrRequest = () => {
	return {
		type: types.CREATE_DSR_TEMPLATE_REQUEST
	};
};

export function createTemplateDsr(createDsrTemplateMetadata) {	
	return async (dispatch) => {
		dispatch(createTemplateDsrRequest());
		try {
			const url = `/template/create`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				createDsrTemplateMetadata,
				{ headers }
			);

			// if (response.data.data.templateCreatedSuccessful === true) {
			// 	response.data.data.redirectUrl && redirectToNewPage(response.data.data.redirectUrl) 
			// }

			dispatch(createTemplateDsrSuccess(response));
				
		} catch (error) {
			dispatch(createTemplateDsrFailure(error));
		}
	};
}


// Get Template Configuration 
export const getTemplateConfigSuccess = (response) => {
	return {
		type: types.GET_DSR_TEMPLATE_CONFIG_SUCCESS,
		payload: response.data
	};
};

export const getTemplateConfigFailure = (error) => {
	return {
		type: types.GET_DSR_TEMPLATE_CONFIG_FAILURE,
		error
	};
};

export const getTemplateConfigRequest = () => {
	return {
		type: types.GET_DSR_TEMPLATE_CONFIG_REQUEST
	};
};

export function getTemplateConfig(templateId) {
	
	return async (dispatch) => {
		dispatch(getTemplateConfigRequest());
		try {
			const url = `/template/get/${templateId}`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.get(url, {
				headers
			});

			if (response.data.data.invalidRequest === true) {
					dispatch(setInvalidRequest(response.data.data.invalidRequest))				
			} 

			else {
				dispatch(getTemplateConfigSuccess(response));
				
				if (response.data.data.dsrPages) {
					dispatch(setDsrPages(response.data.data.dsrPages))
				}

				if (response.data.data.dsrTemplateId) {
					dispatch(setDsrTemplateId(response.data.data.dsrTemplateId))
				}

				if (response.data.data.templateMainContactInfo) {
					dispatch(setDsrTemplateMainContact(response.data.data.templateMainContactInfo))
				}

				if (response.data.data.updatedAt) {
					dispatch(setDsrLastUpdated(response.data.data.updatedAt))
				}

				if (response.data.data.dsrLockMetadata) {
					const {dsrLockStatus, ...setRoomLockMetadata} = response.data.data.dsrLockMetadata || {};
					dispatch(setIsLockedRoom(dsrLockStatus))
					dispatch(setLockedRoomLiveMetadata(setRoomLockMetadata)) 
				}

				// Get other metadata
				const {pageId, dsrPage} = findPageIdByPageType(response.data.data.dsrPages, 'faq')
				
				if (dsrPage) {
					dispatch(setFaqPageId(pageId))
					const faqArray = dsrPage.pageContent[0].faqArray;
					dispatch(setDsrFaqContent(faqArray))
				}

				if (response.data.data.sharedDocsOverview) {
					dispatch(setDsrSharedDocsOverview(response.data.data.sharedDocsOverview))
				}

				dispatch(setDsrLogos(response.data.data.dsrDisplayLogos))
				dispatch(setDsrProperties(response.data.data.dsrProperties))
				dispatch(setDsrDraftStatus(response.data.data.status))
				dispatch(setDsrTitle(response.data.data.dsrTitle))
			}
				
		} catch (error) {
			dispatch(getTemplateConfigFailure(error));
		}
	};
}


//
export const updateDsrTemplateSuccess = (response) => {
	return {
		type: types.UPDATE_DSR_TEMPLATE_SUCCESS,
    payload: response.data
	};
};


export const updateDsrTemplateFailure = (error) => {
	return {
		type: types.UPDATE_DSR_TEMPLATE_FAILURE,
    error
	};
};

export const updateDsrTemplateRequest = () => {
	return {
		type: types.UPDATE_DSR_TEMPLATE_REQUEST
	};
};

export function updateDsrTemplate(updateDsrTemplateMetadata) {
	// PUT API
	return async (dispatch) => {
		dispatch(updateDsrTemplateRequest());
		try {
			const url = '/template/update';
			const headers = await auth.getAccessToken();

			const response = await axiosInstance.put(
				url,
				updateDsrTemplateMetadata,
				{ headers }
			);
			
			if (response.data.data.updateDsrTemplateStatus === 'success') {
				const {sourceEvent, lastSavedAt} = response.data.data || {};

				switch (sourceEvent) {
					case('save-room-properties'): {
						const {dsrProperties, dsrTitle} = updateDsrTemplateMetadata || {};
						
						if (dsrProperties) dispatch(setDsrProperties(dsrProperties));
						if (dsrTitle) dispatch(setDsrTitle(dsrTitle));
						
						break;
					}
					case('save-dsr-template'): {
						const {dsrPages} = updateDsrTemplateMetadata || {};
						dispatch(setDsrPages(dsrPages))
						break;
					}
					case('update-dsr-title'): {
						const {dsrTitle} = updateDsrTemplateMetadata || {};
						dispatch(setDsrTitle(dsrTitle)) 
						break;
					}
					case("take-template-private"):
					case('share-template'): {
						const {dsrProperties} = updateDsrTemplateMetadata || {};
						
						if (dsrProperties) dispatch(setDsrProperties(dsrProperties));
						
						break;
					}
					default: {
						break;
					}
				}

				lastSavedAt && dispatch(setDsrLastUpdated(lastSavedAt))
			}

			if (response.data.data.updatedDsrProperties) {
				dispatch(setDsrProperties(response.data.data.updatedDsrProperties))
			}

			dispatch(updateDsrTemplateSuccess(response));

		} catch (error) {
			dispatch(updateDsrTemplateFailure(error));
		}
	};
}


// Reset update DSR
export const updateDsrTemplateReset = () => {
	return {
		type: types.UPDATE_DSR_TEMPLATE_RESET
	};
};

export function resetUpdateDsrTemplateOutcome() {

	return async (dispatch) => {
		try {
			dispatch(updateDsrTemplateReset());

		} catch (error) {
			dispatch(updateDsrTemplateFailure(error));
		}
	};
}


export const createDsrWithTemplateSuccess = (response) => {
	return {
		type: types.CREATE_DSR_WITH_TEMPLATE_SUCCESS,
		payload: response.data
	};
};

export const createDsrWithTemplateFailure = (error) => {
	return {
		type: types.CREATE_DSR_WITH_TEMPLATE_FAILURE,
		error
	};
};

export const createDsrWithTemplateRequest = () => {
	return {
		type: types.CREATE_DSR_WITH_TEMPLATE_REQUEST
	};
};

export function createDsrWithTemplate(createDsrWithTemplateMetadata) {	
	return async (dispatch) => {
		dispatch(createDsrWithTemplateRequest());
		try {
			const url = `/template/create-dsr`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				createDsrWithTemplateMetadata,
				{ headers }
			);

			dispatch(createDsrWithTemplateSuccess(response));
				
		} catch (error) {
			dispatch(createDsrWithTemplateFailure(error));
		}
	};
}

// 
// Reset update DSR
export const createDsrWithTemplateReset = () => {
	return {
		type: types.CREATE_DSR_WITH_TEMPLATE_RESET
	};
};

export function resetCreateDsrWithTemplateOutcome() {

	return async (dispatch) => {
		try {
			dispatch(createDsrWithTemplateReset());

		} catch (error) {
			dispatch(createDsrWithTemplateFailure(error));
		}
	};
}



export const updateDsrTemplateFaqSuccess = (response) => {
	return {
		type: types.UPDATE_DSR_TEMPLATE_FAQ_SUCCESS,
    payload: response.data
	};
};


export const updateDsrTemplateFaqFailure = (error) => {
	return {
		type: types.UPDATE_DSR_TEMPLATE_FAQ_FAILURE,
    error
	};
};

export const updateDsrTemplateFaqRequest = () => {
	return {
		type: types.UPDATE_DSR_TEMPLATE_FAQ_REQUEST
	};
};

export function updateDsrTemplateFaq(updateDsrTemplateFaqMetadata) {
	// PUT API
	return async (dispatch) => {
		dispatch(updateDsrTemplateFaqRequest());

		try {
			const url = '/template/update-faq';
			const headers = await auth.getAccessToken();

			const response = await axiosInstance.put(
				url,
				{updateDsrTemplateFaqMetadata},
				{ headers }
			);
			
			dispatch(updateDsrTemplateFaqSuccess(response))

		} catch (error) {
			dispatch(updateDsrTemplateFaqFailure(error));
		}
	};
}


// Reset update DSR
export const updateDsrTemplateFaqReset = () => {
	return {
		type: types.UPDATE_DSR_TEMPLATE_FAQ_RESET
	};
};

export function resetUpdateDsrTemplateFaqOutcome() {

	return async (dispatch) => {
		try {
			dispatch(updateDsrTemplateFaqReset());

		} catch (error) {
			dispatch(updateDsrTemplateFaqFailure(error));
		}
	};
}